import styled from 'styled-components';

export const ContentContainer = styled.div`
    max-width: 1030px;
    width: 90%;
    margin: 0 auto;
`;
